import { cx } from "@emotion/css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BlockedActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/BlockedActions";
import { InProgressActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/InProgressActions";
import { WaitingActions } from "src/components/Course/lessons/Lesson/LessonComponents/Actions/WaitingActions";
import { BlockedRepetitionDetails } from "src/components/Course/lessons/Lesson/LessonComponents/Details/BlockedRepetitionDetails";
import InProgressDetails from "src/components/Course/lessons/Lesson/LessonComponents/Details/InProgressDetails";
import { WaitingRepetitionDetails } from "src/components/Course/lessons/Lesson/LessonComponents/Details/WaitingRepetitionDetails";
import { LessonNote } from "src/components/Course/lessons/Lesson/LessonNote";
import { DefaultScore } from "src/components/NewComponents/Views/Details/DefaultDetails";
import DefaultScoreView from "src/components/NewComponents/Views/ScoreViews/DefaultScoreView";

export const isLessonDisabled = (lesson: any): boolean => {
	return lesson.status === "blocked";
};

export const isLessonWaiting = (lesson: any): boolean => {
	return lesson.status === "waiting";
};

export const isLessonResolved = (lesson: any): boolean => {
	return lesson.status === "resolved";
};

interface RepetitionLessonProps {
	lesson: any;
	className?: string;
	folders?: any[];
}

export const RepetitionLesson = ({
	lesson,
	className,
	folders = [],
}: RepetitionLessonProps) => {
	const { t } = useTranslation();
	const [isNoteOpen, setIsNoteOpen] = useState(!!lesson.userNote);
	const toggleNote = () => setIsNoteOpen(!isNoteOpen);
	const isWaiting = isLessonWaiting(lesson);
	const isBlocked = isLessonDisabled(lesson);

	if (isBlocked) {
		return (
			<DefaultScoreView
				className={cx("disabled-lesson", className)}
				Details={<BlockedRepetitionDetails lesson={lesson} className="mr-32" />}
				Actions={<BlockedActions lesson={lesson} />}
			/>
		);
	}

	if (isWaiting) {
		return (
			<DefaultScoreView
				className={cx(
					{
						"disabled-lesson": isLessonDisabled(lesson),
					},
					className,
				)}
				Details={<WaitingRepetitionDetails className="mr-32" lesson={lesson} />}
				Actions={<WaitingActions lesson={lesson} toggleNote={toggleNote} />}
			>
				{isNoteOpen && (
					<LessonNote lesson={lesson} closeNotes={() => setIsNoteOpen(false)} folders={folders} />
				)}
			</DefaultScoreView>
		);
	}

	return (
		<DefaultScoreView
			className={className}
			Details={
				<InProgressDetails
					className="mr-32"
					lesson={lesson}
					Score={
						<DefaultScore
							className="purple-box"
							title={t("course.lessons.revision")}
						/>
					}
				/>
			}
			Actions={<InProgressActions lesson={lesson} toggleNote={toggleNote} />}
		>
			{isNoteOpen && (
				<LessonNote lesson={lesson} closeNotes={() => setIsNoteOpen(false)} folders={folders} />
			)}
		</DefaultScoreView>
	);
};
